export  const containerStyle = ()=>{
    return (
        {
                display: 'grid',    
                gridTemplateColumns: '1fr',
                alignContent : 'start',
                alignItems: 'center',
                justifyContent: 'stretch',
                gridRowGap: '2px',
                marginLeft: '0px',
                marginRight: '0px',
                marginTop: '0px',
                marginBottom: '0px'
        }
    )
  }  


export  const itemStyle = () => {
      return {
        display: "grid",
        gridTemplateColumns: "10fr 1fr 1fr",
        gridTemplateRows: "auto",
        color: "white",
        fontSize: "14px",

        backgroundColor: "blue",
        alignItems: "center",
        justifyContent: "right"
      };
    };

export  const columnStyle1 = () => {
      return {
        marginLeft: "20px"
      };
    };

